import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExceljsonUploadPopupComponent } from 'src/app/shared/components/exceljson-upload-popup/exceljson-upload-popup.component';
import { PdfViewerComponent } from 'src/app/shared/components/pdf-viewer/pdf-viewer.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getRequestersOptions } from 'src/app/shared/helpers/Drop-down-options';
import { normalizeSegment } from 'src/app/shared/helpers/dropdown-options';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-retrive-form',
  templateUrl: './retrive-form.component.html',
  styleUrls: ['./retrive-form.component.scss'],
})
export class RetriveFormComponent {
  retriveForm!: FormGroup;
  RetriveData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  paginatedData: any[] = [];
  elements: any;
  addRowdData: any[] = [];
  tableData: any[] = [];
  rowData: any = {};
  lastTableDataRowIndex: number = 0;
  requestersOptions: any;
  pdfData: any;
  userName: any;
  @ViewChild(MatSort) sort!: MatSort;
  shipNameSuggestions: any[] = [];
  errorMessage: any[] = [];
pdfUrl: any;
blobUrl: string | null = null; 
isLoading: boolean = true;
isFilterOpen: boolean = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private sanitizer: DomSanitizer,
    private overlayService: OverlapService,
      private dialog: MatDialog 
  ) {
    this.retriveForm = this.fb.group({
      cosp: [''],
      eosp: [''],
      requesters: [''],
      shipName: [''],
    });
    this.requestersOptions = getRequestersOptions();
  }


  ngOnInit() {
    this.isLoading = true;
this.requestFormService.getReports().subscribe((data: any[]) => {
  const selectedRadio = localStorage.getItem('selectedRadio');
  const selectedOperator = localStorage.getItem('selectedOperator');

  let filteredData = data;

  if (selectedRadio === 'myShips' && selectedOperator) {
    filteredData = data.filter(
      item => item.eigerpic === selectedOperator
    );
  }

  // 👉 Always normalize (for both cases)
  this.RetriveData = filteredData.map(item => ({
    ...item,
    normalizedSegment: normalizeSegment(item.segment)
  }));

  this.paginateData();
  this.isLoading = false;
});
    this.userName = localStorage.getItem('username') || 'Meraki - Operations';
    this.getError();
  }
  
  getError() {
    this.requestFormService.getErrorMessage().subscribe(
      (data) => {
        if (Array.isArray(data.data)) {
          this.errorMessage = data.data; // Use the response directly if it's an array
        } else {
          console.error('Unexpected API response format:', data);
          this.errorMessage = []; // Fallback to an empty array if the response is not an array
        }
      },
      (error) => {
        console.error('Error fetching error messages:', error);
        this.errorMessage = []; // Fallback in case of an API error
      }
    );
  }
  getErrorMessage(errorId: any) {
    if (!errorId.mvr_pdflink && !errorId.evr_pdflink && errorId.error_id) {
      const error = (this.errorMessage || []).find(
        (err) => err.error_id === errorId.error_id
      );
      return error ? error.error_msg : 'Error message not found';
    }
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.RetriveData.filter((item: any) =>
        item.ship.toLowerCase().includes(inputValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  removeShipPrefix(shipName: string): string {
    if (!shipName) {
      return '';
    }
  
    // Remove known prefixes
    const cleanedName = shipName.replace(/^(MV|MT)\s*/i, '');
  
    // Capitalize first letter, rest lowercase
    return cleanedName
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.RetriveData?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }

  compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (sortActive === 'cosp' || sortActive === 'eosp') {
      const dateA = new Date(a[sortActive]);
      const dateB = new Date(b[sortActive]);

      if (dateA < dateB) {
        return isAsc ? -1 : 1;
      } else if (dateA > dateB) {
        return isAsc ? 1 : -1;
      }
      return 0;
    }

    if (a === null || a === undefined) return isAsc ? -1 : 1;
    if (b === null || b === undefined) return isAsc ? 1 : -1;

    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum < bNum ? -1 : 1) * (isAsc ? 1 : -1);
    }

    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    return (a[sortActive] < b[sortActive] ? -1 : 1) * (isAsc ? 1 : -1);
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  clearClick() {
    this.retriveForm.reset();
    this.paginateData();
  }
  filterClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        // Format date as DD-MM-YYYY
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    };
    const cosp = this.retriveForm.get('cosp')?.value;
    const eosp = this.retriveForm.get('eosp')?.value;
    const requesters = this.retriveForm.get('requesters')?.value;
    const shipName = this.retriveForm.get('shipName')?.value;

    // Function to format date to YYYY-MM-DD
    const formatDateToYYYYMMDD = (dateString: string | null) => {
      if (dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
      }
      return null;
    };

    const fromDate = formatDateToYYYYMMDD(cosp);
    const toDate = formatDateToYYYYMMDD(eosp);

    const filteredData = this.RetriveData.filter((element: any) => {
      const elementDate = element.updatedAt ? parseDate(element.updatedAt) : '';

      // Check if the element date is within the range
      const dateInRange =
        (!fromDate || (elementDate && elementDate >= fromDate)) &&
        (!toDate || (elementDate && elementDate <= toDate));

      const segmentValid =
        !requesters ||
        element.merakiPic?.toLowerCase() === requesters.toLowerCase();

      const conditionValid =
        !shipName ||
        element.ship?.toLowerCase().includes(shipName.toLowerCase());

      return dateInRange && segmentValid && conditionValid;
    });

    console.log(filteredData);
    this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    this.currentPage = 0;
  }

  // showDetails(row: any) {
  //   this.sharedDataService.setFleetViewRowDat(row);
  //   this.router.navigate(['/vp-requestForm']);
  // }
showDetails(row: any) {
  this.sharedDataService.setFleetViewRowDat(row);

  const dialogRef = this.dialog.open(ExceljsonUploadPopupComponent, {
    width: '600px',
    disableClose: true,
    panelClass: 'excel-upload-popup',
    data: row
  });

dialogRef.afterClosed().subscribe((result) => {
  if (result?.type) {
    this.router.navigate(['/vp-requestForm'], {
      queryParams: {
        reportType: result.type  
      }
    });
  }
});

}

  padWithZero(value: number): string {
    return value < 10 ? '0' + value : '' + value;
  }


  
  download(row: any) {
    const baseUrl: string = window.location.origin;  
    const pdfLink = row.mvr_pdflink || row.evr_pdflink;
  
    if (pdfLink) {
      const fullUrl = baseUrl + pdfLink;
      this.toastr.success(ToasterMessages.PdfProcessing);
  
      fetch(fullUrl)
        .then((response) => {
          if (!response.ok) {
            // Handle non-2xx responses
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
          }
          return response.blob();
        })
        .then((blob) => {
          // Pass the PDF blob to the overlay service
          this.overlayService.showPdf(blob);
          this.toastr.clear() ;
        })
        .catch((error) => {
          this.toastr.clear();
          this.toastr.info('Record not found');
          console.error('Error loading PDF:', error);
         
        });
    } else {
      console.error('No valid PDF link available.');
    }
  }


  
  
  exportClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        // Format date as DD-MM-YYYY
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    };
    // Use filtered data or elements data to export
    const data = this.paginatedData || this.elements;
    let csvHeader;
    let csvData;

    if (this.userName === 'Zeronorth ZN') {
      csvHeader = 'S.No,Ship Name,Cosp,Eosp,Reported Date,Company';

      // Generate CSV rows
      csvData = data
        .map((element: any, rowIndex: number) => {
          const cosp = element.cosp !== 'null' ? element.cosp : '';
          const eosp = element.eosp !== 'null' ? element.eosp : '';
          const reportedDate = element.updatedAt
            ? parseDate(element.updatedAt)
            : '';
          const user = this.userName || ''; // Add user

          // Return CSV row
          return `${rowIndex + 1},${this.removeShipPrefix(
            element.ship
          )},${cosp},${eosp},${reportedDate},${user}`;
        })
        .join('\n');
    } else {
      csvHeader =
        'S.No,Ship Name,Cosp,Eosp,Segment,MerakiPic,Reported Date,Company';

      // Generate CSV rows
      csvData = data
        .map((element: any, rowIndex: number) => {
          const cosp = element.cosp !== 'null' ? element.cosp : '';
          const eosp = element.eosp !== 'null' ? element.eosp : '';
          const segment =
            this.userName !== 'Zeronorth ZN' ? element.segment : '';
          const merakiPic =
            this.userName !== 'Zeronorth ZN' ? element.merakiPic : '';
          const reportedDate = element.updatedAt
            ? parseDate(element.updatedAt)
            : '';
          const user = this.userName || ''; // Add user

          // Return CSV row
          return `${rowIndex + 1},${this.removeShipPrefix(
            element.ship
          )},${cosp},${eosp},${segment},${merakiPic},${reportedDate},${user}`;
        })
        .join('\n');
    }

    // Combine header and data
    const csvContent = `${csvHeader}\n${csvData}`;

    // Create Blob and initiate download
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'myrequest_table_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
   private segmentColorMap: { [key: string]: string } = {
    mr2: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
export declare class PageEvent {
  pageIndex: number;
  previousPageIndex?: number;
  pageSize: number;
  length: number;
}
